import request from '../request'

// 获取图形验证码
export const getVcode = function(data) {
	return request({
		url: 'sysUser/getVerificationCode',
		method: 'post',
		data
	})
}

// 账号密码登录
export const loginIn = function(data) {
	return request({
		url: 'userLogin/login',
		method: 'post',
		data
	})
}

// 手机获取验证码  ---  叶凡
export const getAuthCode = function(data) {
	return request({
		url: 'sms/getAuthCode',
		method: 'post',
		data
	})
}

// 手机号码登录
export const mobileLogin = function(data) {
	return request({
		url: 'userLogin/mobileLogin',
		method: 'post',
		data
	})
}

// 注册时获取验证码
export const sendSingleCode = function(data) {
	return request({
		url: 'sms/sendSingleCode',
		method: 'post',
		data
	})
}

// 验证手机号和会员号
export const getPhone = function(data) {
	return request({
		url: 'public/getPhone',
		method: 'post',
		data
	})
}

// 注册
export const saveUserRegister = function(data) {
	return request({
		url: 'public/saveUserRegister',
		method: 'post',
		data
	})
}

// 获取注册协议
export const showDealInfo = function(data) {
	return request({
		url: 'ngsManage/showDealInfo',
		method: 'post',
		data
	})
}


// 获取注册协议列表
export const getDeals = function(data) {
	return request({
		url: 'public/getDealsByScene',
		method: 'post',
		data
	})
}

// 获取注册协议详情
export const getDealDetail = function(data) {
	return request({
		url: 'public/getDealDetail',
		method: 'post',
		data
	})
}


// 微信/QQ 登录
export const wechat = function(data) {
	return request({
		url: 'oauth/render',
		method: 'post',
		data
	})
}


// 重置密码
export const updatePassByPhone = function(data) {
	return request({
		url: 'sms/updatePassByPhone',
		method: 'post',
		data
	})
}

// 绑定手机 --- 刘献根
export const userBinder = function(data) {
  return request({
      url: 'oauth/userBinder',
      method: 'post',
      data
  })
}

// 添加关联企业，企业法人获取验证码  ---  叶凡
export const getLegalPhoneCode = function(data) {
  return request({
      url: 'oauth/sendLegalSms',
      method: 'post',
      data
  })
}

// 授权成功后登录 --- 刘献根
export const oauthLogin = function(data) {
  return request({
      url: '/oauth/oauthLogin',
      method: 'post',
      data
  })
}

// 协议已读状态变更
export const readDeal = function(data) {
  return request({
      url: '/dealRead/readDeal',
      method: 'post',
      data
  })
}


//  发送语音验证码 --- 孙强
export const sendVoiceCode = function (data) {
    return request({

        url: '/sms/sendVoiceCode',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/module/index.js